import React from 'react';
import './PageLoader.css';

export default function PageLoader() {
  return <div className="haven-page-loader" role="status" aria-live="polite" aria-label="Haven is loading">
    <svg className="haven-loading-circle" viewBox="0 0 80 80" width="80" height="80" aria-hidden="true">
      <circle className="haven-loading-track" cx="40" cy="40" r="30" />
      <g className="haven-loading-orbit" fill="none" strokeWidth="5" strokeLinecap="round">
        <circle cx="40" cy="40" r="30" stroke="#3DA9C9" strokeDasharray="32 157" transform="rotate(-90 40 40)" />
        <circle cx="40" cy="40" r="30" stroke="#B8D96B" strokeDasharray="32 157" />
        <circle cx="40" cy="40" r="30" stroke="#E85A9D" strokeDasharray="32 157" transform="rotate(90 40 40)" />
        <circle cx="40" cy="40" r="30" stroke="#E98573" strokeDasharray="32 157" transform="rotate(180 40 40)" />
      </g>
      <circle className="haven-loading-heart" cx="40" cy="40" r="5" fill="#27232B" />
    </svg>
  </div>;
}
